import { render, staticRenderFns } from "./StatementAddServices.vue?vue&type=template&id=bcf4921e&"
import script from "./StatementAddServices.vue?vue&type=script&lang=js&"
export * from "./StatementAddServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports